import * as React from 'react';
import * as Yup from 'yup';

import { Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Formik, FormikActions, FormikProps } from 'formik';
import { mergeFields, processApiError, toFormGroupStyle } from 'common/utils/form';

import { FormErrorFeedback } from 'common/components/form/FormErrorFeedback';
import { TAG_TYPES } from './VftiRegistrants';
import { VftiRegistrant } from 'common/api/models/VftiRegistrant';
import { VftiRegistrantApi } from 'common/api/resources/VftiRegistrantApi';
// import { toSlug } from 'common/utils/utils';
import { Analytics } from 'common/utils/Analytics';
// import { FormInput } from 'common/components/form/FormInput';
// import { MediaUpload } from 'common/components/form/MediaUpload';
import { Feature } from 'common/features/Feature';
import { AppState } from 'common/models/AppState';
import { canViewBadges } from 'common/features/canViewBadges';

interface VftiRegistrantsDialogProps {
  vftiRegistrant?: VftiRegistrant;
  appState: AppState;
  onSave: (saved: string) => void;
  onCancel: () => void;
}

class VftiRegistrantsFormValues {
  email: string = '';
  //  shortName: string = '';
  //  imagePath: string = '';
  //  description: string = '';
  //  type: string = '';
}

export class VftiRegistrantsDialog extends React.Component<VftiRegistrantsDialogProps> {
  vftiRegistrantTypes = canViewBadges(Feature.badges, this.props.appState.config, this.props.appState.user)
    ? [...TAG_TYPES, { label: 'Badge', value: 'BADGE' }]
    : TAG_TYPES;

  initialValues() {
    return mergeFields(new VftiRegistrantsFormValues(), this.props.vftiRegistrant);
  }

  handleSubmit = (values: VftiRegistrantsFormValues, actions: FormikActions<VftiRegistrantsFormValues>) => {
    const VftiRegistrantData = {
      ...values,
      //      imagePath: values.imagePath === '' ? '' : values.imagePath,
      //      type: VftiRegistrant.Type[values.type],
    };
    const call =
      this.props.vftiRegistrant && this.props.vftiRegistrant.id
        ? VftiRegistrantApi.updateVftiRegistrant(this.props.vftiRegistrant.id, VftiRegistrantData)
        : VftiRegistrantApi.createVftiRegistrant(VftiRegistrantData);
    const analyticsEvent =
      this.props.vftiRegistrant && this.props.vftiRegistrant.id
        ? Analytics.vftiRegistrant.update
        : Analytics.vftiRegistrant.create;
    call.then(
      res => {
        this.props.onSave(
          this.props.vftiRegistrant && this.props.vftiRegistrant.id ? this.props.vftiRegistrant.id : (res as any).id
        );
        analyticsEvent();
        actions.setSubmitting(false);
        actions.setStatus(undefined);
      },
      err => {
        processApiError<VftiRegistrantsDialogProps, VftiRegistrantsFormValues>(err, actions);
      }
    );
  };

  render() {
    const title =
      this.props.vftiRegistrant && this.props.vftiRegistrant.id ? 'Edit VftiRegistrant' : 'Add VftiRegistrant';

    return (
      <Modal size="md" isOpen={!!this.props.vftiRegistrant} toggle={this.props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          validationSchema={Yup.object().shape({
            email: Yup.string().required('Required'),
            //            type: Yup.string().required('Required'),
            //            description: Yup.string()
            //              .min(10, 'Please describe this vftiRegistrant so people in 6 months will know what it is.')
            //              .required('Required'),
          })}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<VftiRegistrantsFormValues>) => (
            <form onSubmit={form.handleSubmit} noValidate={true}>
              <ModalHeader toggle={this.props.onCancel}>{title}</ModalHeader>
              <ModalBody>
                {this.props.vftiRegistrant && this.props.vftiRegistrant.id && (
                  <div className="mb-3">Edit Email Address for VFTI Registrant</div>
                )}
                <FormGroup color={toFormGroupStyle('email', form)}>
                  <Label for="email">Email</Label>
                  <Input
                    id="email"
                    value={form.values.email}
                    onChange={form.handleChange}
                    onBlur={form.handleBlur}
                    spellCheck={false}
                    autoComplete="off"
                  />
                  <FormErrorFeedback field="email" form={form} />
                </FormGroup>
                {form.status && <div className="alert alert-danger">{form.status}</div>}
              </ModalBody>
              <ModalFooter>
                <div>
                  <Button color="secondary" onClick={this.props.onCancel}>
                    Cancel
                  </Button>{' '}
                  <Button color="primary" type="submit">
                    Save
                  </Button>
                </div>
              </ModalFooter>
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/VftiRegistrants/VftiRegistrantDialog.tsx